module.exports = __webpack_public_path__ + "img/16ce65fe9c422ba275e5d5fc3ec84d7e.54a5ea05.jpg";